import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { reloadCurrentLocation } from '../../../iwRouter/LocationHelper';
import { WarningTriangleSVG } from '../../../svgComponents/warningTriangleSVG';
import styles from './FallbackErrorModal.module.css';
import messages from './FallbackErrorModal.messages';
import { TrackErrorModalOpened } from '../../../tracking/amplitude.helpers';

class FallbackErrorModal extends Component {
    componentDidMount() {
        TrackErrorModalOpened();
    }

    render() {
        return (
            <div
                data-testid="fallback-error-modal"
                className={styles.FallbackErrorModal}
            >
                <WarningTriangleSVG className={styles.icon} />
                <div className={styles.label}>
                    <FormattedMessage {...messages.label} />
                </div>
                <button
                    className={styles.button}
                    onClick={() => reloadCurrentLocation()}
                >
                    <FormattedMessage {...messages.refresh} />
                </button>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default FallbackErrorModal;
